const UserStatus = {
  NEWTEACHER: "newteacher",
  WAITINGFORAPPROVAL: "waitingforapproval",
  APPROVED: "approved"
};

export default UserStatus;
